import './About.css'

function AboutPage({ t }) {
  return (
    <div className="page">
    <section className="section">
      <div className="section-header">
        <h2>{t.about.title}</h2>
        <p>{t.about.lead}</p>
        {t.about.paragraphs?.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
      <div className="about-blocks">
        <div className="vision-card">
          <h3>{t.about.vision.title}</h3>
          <p>{t.about.vision.body}</p>
        </div>
        <div className="values-card">
          <h3>{t.about.values.title}</h3>
          <div className="values-grid">
            {t.about.values.items.map((value) => (
              <div className="value-item" key={value.title}>
                <strong>{value.title}</strong>
                <span>{value.body}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="cards">
        {t.about.cards.map((card) => (
          <article className="card" key={card.title}>
            <h3>{card.title}</h3>
            <p>{card.body}</p>
          </article>
        ))}
      </div>
    </section>
    </div>
  )
}

export default AboutPage
